import * as React from 'react';
import {ProductsAcceptorFilterViewBaseProps} from '../model';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {ProductsAcceptorFilterDesktop} from './views/desktop';
import {ProductsAcceptorFilterMobile} from './views/mobile';
import {ProductsAcceptorFilterVisuallyImpaired} from './views/visuallyImpaired';

interface Props extends ProductsAcceptorFilterViewBaseProps {
  visuallyImpaired?: boolean;
}

export default ({visuallyImpaired, ...props}: Props) => {
  const isDesktop = useIsDesktop();

  if (visuallyImpaired) {
    return <ProductsAcceptorFilterVisuallyImpaired {...props} />;
  } else {
    return isDesktop ? <ProductsAcceptorFilterDesktop {...props} /> : <ProductsAcceptorFilterMobile {...props} />;
  }
};
